import { ScientificResearch } from "@/api/superAdmin";
import { convertFileUrlToFileName } from "@/lib/utils";
import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import LongDescription from "../LongDescription";

export const useScientificResearchColumn = () => {
  const { t } = useTranslation();

  const columns: ColumnDef<ScientificResearch>[] = [
    {
      accessorKey: "title",
      header: () => <div className="text-left">{t("common.label.title")}</div>,
      cell: ({ row }) => {
        const value = (row.getValue("title") as string) || "--";
        return <div className="text-left">{value}</div>;
      },
    },
    {
      accessorKey: "description",
      header: () => (
        <div className="text-left">{t("common.label.description")}</div>
      ),
      cell: ({ row }) => {
        const value = (row.getValue("description") as string) || "--";
        <LongDescription text={value} className="text-left max-w-[400px]" />;
      },
    },
    {
      accessorKey: "file",
      header: () => <div className="text-left">{t("common.label.file")}</div>,
      cell: ({ row }) => {
        const value = (row.getValue("file") as string) || "--";
        let fileName = convertFileUrlToFileName(value);
        return (
          <div className="text-left">
            <a
              className="text-primary hover:underline"
              href={value}
              target="_blank"
              rel="noreferrer"
            >
              {fileName}
            </a>
          </div>
        );
      },
    },
  ];

  return columns;
};
